import { Component, ContentChild, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fpx-fieldset',
  templateUrl: './fpx-fieldset.component.html',
  styleUrls: ['./fpx-fieldset.component.scss']
})
export class FpxFieldsetComponent {

  @ContentChild("content") content!: ElementRef;
  @Input () legend: string = '';
  @Input () legendAlign: 'left' | 'right' | 'center' = 'left';

  constructor() { }

}
